module.exports = __webpack_public_path__ + "bojan_square-b5dbe383a3c287f69a521d17d0a60292.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/se/bojan_square.png
// module id = 1192
// module chunks = 1 2